(() => {
  const body = document.body;
  const navToggle = document.querySelector('[data-mobile-nav-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  const closeMobileNav = () => {
    if (!navToggle || !mobileNav) return;
    navToggle.setAttribute('aria-expanded', 'false');
    mobileNav.classList.remove('is-open');
    body.classList.remove('mobile-menu-open');
  };

  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', () => {
      const willOpen = navToggle.getAttribute('aria-expanded') !== 'true';
      navToggle.setAttribute('aria-expanded', String(willOpen));
      mobileNav.classList.toggle('is-open', willOpen);
      body.classList.toggle('mobile-menu-open', willOpen);
    });

    mobileNav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeMobileNav);
    });
  }

  const header = document.querySelector('[data-site-header]');
  if (header && header.dataset.stickyType === 'on-scroll-up') {
    let previousY = window.scrollY;
    window.addEventListener('scroll', () => {
      const currentY = window.scrollY;
      const movingDown = currentY > previousY;
      header.classList.toggle('header-hidden', movingDown && currentY > 180 && !body.classList.contains('mobile-menu-open'));
      header.classList.toggle('header-scrolled', currentY > 8);
      previousY = currentY;
    }, { passive: true });
  }

  const searchDetails = document.querySelector('[data-header-search]');
  if (searchDetails) {
    searchDetails.addEventListener('toggle', () => {
      if (searchDetails.open) {
        closeMobileNav();
        window.setTimeout(() => searchDetails.querySelector('input[type="search"]')?.focus(), 50);
      }
    });

    document.addEventListener('click', (event) => {
      if (searchDetails.open && !searchDetails.contains(event.target)) searchDetails.removeAttribute('open');
    });
  }

  const galleryItems = Array.from(document.querySelectorAll('[data-gallery-item]'));
  const lightbox = document.querySelector('[data-gallery-lightbox]');
  if (galleryItems.length && lightbox) {
    const image = lightbox.querySelector('[data-lightbox-image]');
    const close = lightbox.querySelector('[data-lightbox-close]');
    const previous = lightbox.querySelector('[data-lightbox-prev]');
    const next = lightbox.querySelector('[data-lightbox-next]');
    let index = 0;
    let lastFocused = null;

    const show = (newIndex) => {
      index = (newIndex + galleryItems.length) % galleryItems.length;
      const item = galleryItems[index];
      image.src = item.dataset.gallerySrc;
      image.alt = item.querySelector('img')?.alt || 'Luxe Lifestyles gallery image';
    };

    const open = (newIndex) => {
      lastFocused = document.activeElement;
      show(newIndex);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      body.classList.add('lightbox-open');
      close?.focus();
    };

    const hide = () => {
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      body.classList.remove('lightbox-open');
      lastFocused?.focus?.();
    };

    galleryItems.forEach((item, itemIndex) => {
      item.addEventListener('click', () => open(itemIndex));
    });
    close?.addEventListener('click', hide);
    previous?.addEventListener('click', () => show(index - 1));
    next?.addEventListener('click', () => show(index + 1));
    lightbox.addEventListener('click', (event) => { if (event.target === lightbox) hide(); });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMobileNav();
        searchDetails?.removeAttribute('open');
        if (!lightbox.hidden) hide();
      }
      if (!lightbox.hidden && event.key === 'ArrowLeft') show(index - 1);
      if (!lightbox.hidden && event.key === 'ArrowRight') show(index + 1);
    });
  } else {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMobileNav();
        searchDetails?.removeAttribute('open');
      }
    });
  }

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', () => {
      const button = form.querySelector('[type="submit"]');
      if (!button) return;
      button.dataset.originalText = button.textContent;
      button.textContent = 'Adding…';
      button.setAttribute('aria-busy', 'true');
    });
  });
})();
